import axios from 'axios';
import ApiGet from '../sections/mainheader/apiget';

class LogoutService {
    constructor(apiUrl) {
        this.GetApiUrl = apiUrl;    
        console.log(`${this.GetApiUrl}Login/Logout`);

        this.Logout = () => (axios.post(`${this.GetApiUrl}Login/Logout`));
    }
}

export default ApiGet().then((apiUrl) => new LogoutService(apiUrl));
